(function () {
  'use strict';

  var worldBounds = { north: 85.05112878, south: -85.05112878, west: -180, east: 180 };
  window.trackTakeDriveMapEvent = function (action, map) {
    if (!window.IS_PRODUCTION || typeof window.gtag !== 'function') return;
    try {
      window.gtag('event', 'take_drive_map_' + action, {
        map_variant: map.getDiv().id === 'take-drive-map-canvas' ? 'us' : 'international',
        zoom_level: Math.round(map.getZoom() || 0),
        language: document.documentElement.lang || 'en',
        input_type: window.matchMedia('(pointer: coarse)').matches ? 'touch' : 'mouse'
      });
    } catch (error) {
      // Analytics must never interrupt map interaction.
    }
  };

  window.configureTakeDriveMapBounds = function (map) {
    if (map.__takeDriveBoundsConfigured) return;
    map.__takeDriveBoundsConfigured = true;
    var element = map.getDiv();
    var worldZoom = 0;
    var edgeReached = false;
    var previousWidth = 0;
    var previousHeight = 0;

    function resetWorldView() {
      map.setZoom(worldZoom);
      map.setCenter({ lat: 0, lng: 0 });
    }
    map.resetTakeDriveWorldView = resetWorldView;

    function resize() {
      var width = element.clientWidth;
      var height = element.clientHeight;
      if (!width || !height || (width === previousWidth && height === previousHeight)) return;
      var wasWorldView = !previousWidth || Math.abs((map.getZoom() || 0) - worldZoom) < 0.01;
      previousWidth = width;
      previousHeight = height;
      worldZoom = Math.max(0, Math.ceil(Math.log2(Math.max(width, height) / 256)));
      map.setOptions({ minZoom: worldZoom, isFractionalZoomEnabled: false });
      if (wasWorldView) resetWorldView();
    }

    map.setOptions({
      isFractionalZoomEnabled: false,
      draggable: true,
      gestureHandling: 'greedy',
      restriction: {
        latLngBounds: worldBounds,
        strictBounds: true
      },
      tilt: 0,
      heading: 0,
      tiltInteractionEnabled: false,
      headingInteractionEnabled: false,
      backgroundColor: '#DFE0D1'
    });
    map.addListener('dragstart', function () { edgeReached = false; });
    resize();
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(function () {
        if (element.isConnected) resize();
        else observer.disconnect();
      });
      observer.observe(element);
    }
    map.addListener('dragend', function () {
      window.trackTakeDriveMapEvent('drag_end', map);
      var center = map.getCenter();
      if (edgeReached || (center && (Math.abs(center.lat()) > worldBounds.north - 1 ||
          Math.abs(center.lng()) > worldBounds.east - 1))) {
        window.trackTakeDriveMapEvent('boundary_reached', map);
      }
    });
  };
})();
